module.exports = "<div class=\"form-component\">\r\n    <div class=\"fc-title\">\r\n      {{'ASYNC_QUOTATION_RESULT' | i18next}}\r\n    </div>\r\n  </div>\r\n  \r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/quotationResultAsyncDesigner.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/flow-actions/quotationResultAsyncDesigner.component.html
// module chunks = main